// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExceptionOutlinedSvg from "@ant-design/icons-svg/es/asn/ExceptionOutlined";
import AntdIcon from '../components/AntdIcon';

var ExceptionOutlined = function ExceptionOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ExceptionOutlinedSvg
  }));
};

ExceptionOutlined.displayName = 'ExceptionOutlined';
export default React.forwardRef(ExceptionOutlined);